import { useQuery } from "@apollo/client";
import { FloorOverlay, GetAllZonesQueryResult } from "generated/graphql";
import { GET_ALL_ZONES } from "lib/zones";
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { getGoogleMaps } from "config/GoogleMaps";
import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { LocationPosition } from "Modules/ShiftPlayback/PlaybackLocationsLoader";
import { LinearProgress } from "@material-ui/core";

const MapContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export interface ZoneAddMapProps {
  floorOverlays: Pick<
    FloorOverlay,
    | "BuildingId"
    | "CenterLat"
    | "CenterLng"
    | "D_diff"
    | "FloorNumber"
    | "Id"
    | "ImageUrl"
    | "Name"
    | "Rot"
    | "created_at"
    | "k_diff"
    | "updated_at"
    | "AndroidFloors"
  >[];
  onZoneAdd: (latLngs: LocationPosition[]) => void;
  boundary?: LocationPosition[] | null;
  holes: LocationPosition[][];
  mapId: string;
  innerRef: any;
  holesCount: number;
}
interface ZoneAddMapState {
  currentFloorNumber: number;
  //@ts-ignore
  currentLocation?: { lat: number; lng: number };
  layerToggle: boolean;
}

const DEFAULT_STATE: ZoneAddMapState = {
  currentFloorNumber: 0,
  layerToggle: false,
};
//@ts-ignore
let map: any;
let poly: google.maps.Polygon;
export default function HolesAddMap(props: ZoneAddMapProps) {
  const { getImageUrl } = useContext(AuthContext);
  const { floorOverlays } = props;
  const [state, setState] = useState(DEFAULT_STATE);

  const { currentBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetAllZonesQueryResult = useQuery(
    GET_ALL_ZONES,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );

  var overlay: google.maps.OverlayView;

  let drawingManager: google.maps.drawing.DrawingManager;
  //@ts-ignore
  var loc_center: google.maps.LatLng;
  var CenterLat: number;
  var CenterLng: number;
  var k_diff: number = 0.005;
  var D_diff: number = 0.01;
  var rot: number = 0;

  const initMap = async (mapId: string) => {
    loc_center = new google.maps.LatLng(
      currentBuilding!.centerLat,
      currentBuilding!.centerLong
    );
    let url = "";
    if (!!getImageUrl) {
      url = await getImageUrl(
        "overlays",
        currentBuilding?.Id +
          "/" +
          floorOverlays[state.currentFloorNumber].Id +
          ".jpg"
      );
    }
    class DebugOverlay extends google.maps.OverlayView {
      //@ts-ignore
      map_?: google.maps.Map;
      opacity?: number;
      //@ts-ignore
      private bounds: google.maps.LatLngBounds;
      private image: string;
      private div?: HTMLElement;
      //@ts-ignore
      constructor(bounds: google.maps.LatLngBounds, image: any) {
        super();
        this.bounds = bounds;
        this.image = image;
      }

      onAdd() {
        this.div = document.createElement("div");
        this.div.style.borderStyle = "none";
        this.div.style.borderWidth = "0px";
        this.div.style.position = "absolute";
        this.div.style.visibility = "visible";
        var img = document.createElement("img");
        img.src = this.image;
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.opacity = "1";
        img.style.position = "absolute";
        img.style.transform = "rotate(" + rot + "rad)";
        this.div.appendChild(img);
        //@ts-ignore
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(this.div);
      }

      draw() {
        //@ts-ignore
        var overlayProjection = this.getProjection();
        var sw = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getSouthWest()
        );
        var ne = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getNorthEast()
        );
        var div = this.div;
        div!.style.left = sw.x + "px";
        div!.style.top = ne.y + "px";
        div!.style.width = ne.x - sw.x + "px";
        div!.style.height = sw.y - ne.y + "px";
        div!.style.transform = "rotate(" + rot + "deg)";
      }

      onRemove() {
        this?.div?.parentNode?.removeChild(this.div);
        delete this.div;
      }
    }
    const mapElement = props.innerRef.current;
    var mapOptions = {
      zoom: 18,
      center: loc_center,
      backgroundColor: "#051932",
      disableDefaultUI: true,
    };

    let initialize = () => {
      const customStyled = [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ];
      map.set("styles", customStyled);
      //@ts-ignore
      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      //@ts-ignore
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      //@ts-ignore
      var bounds = new window.google.maps.LatLngBounds(newPointA, newPointB);
      var srcImage = url; //"https://res.cloudinary.com/dx8nclins/image/upload/v1569765645/buildings/fb10989e-942e-4142-8687-e7e903b03cef.png";

      overlay = new DebugOverlay(bounds, srcImage);
      overlay.setMap(map);

      drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        // drawingControlOptions: {
        //   position: google.maps.ControlPosition.TOP_CENTER,
        //   drawingModes: [
        //     google.maps.drawing.OverlayType.POLYGON,
        //   ],
        // },
        // circleOptions: {
        //   fillColor: "#ffff00",
        //   fillOpacity: 1,
        //   strokeWeight: 5,
        //   clickable: false,
        //   editable: true,
        //   zIndex: 1,
        // },
      });
      drawingManager.setMap(map);
      drawPoly();
      google.maps.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          if (event.type == "circle") {
            var radius = event.overlay.getRadius();
          } else if (event.type == "polygon") {
            const pathArray = event.overlay.getPath().getArray();
            const latLngs: LocationPosition[] = [];
            pathArray.forEach((element: any) => {
              latLngs.push({
                lat: element.lat(),
                lng: element.lng(),
              });
            });
            event.overlay.setMap(null);
            props.onZoneAdd(latLngs);
          }
        }
      );

      const floorChange = async (controlDiv: HTMLElement): Promise<any> => {
        var controlUI = document.createElement("div");
        controlUI.style.backgroundColor = "#fff";
        controlUI.style.marginRight = "5px";
        controlUI.style.border = "2px solid #fff";
        controlUI.style.borderRadius = "3px";
        controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI.style.cursor = "pointer";
        controlUI.style.marginBottom = "22px";
        controlUI.style.textAlign = "center";
        controlDiv.appendChild(controlUI);

        var controlText = document.createElement("div");
        controlText.style.color = "rgb(25,25,25)";
        controlText.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText.style.fontSize = "16px";
        controlText.style.lineHeight = "38px";
        controlText.style.paddingLeft = "5px";
        controlText.style.paddingRight = "5px";
        controlText.innerHTML = "Floor Up";
        controlUI.appendChild(controlText);

        controlUI.addEventListener("click", async () => {
          console.log("floor up");

          if (state.currentFloorNumber === floorOverlays.length - 1) {
            console.log("highest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber + 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;

            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });

        var controlUI2 = document.createElement("div");
        controlUI2.style.backgroundColor = "#fff";
        controlUI2.style.marginRight = "5px";
        controlUI2.style.border = "2px solid #fff";
        controlUI2.style.borderRadius = "3px";
        controlUI2.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI2.style.cursor = "pointer";
        controlUI2.style.marginBottom = "22px";
        controlUI2.style.textAlign = "center";
        controlDiv.appendChild(controlUI2);

        var controlText2 = document.createElement("div");
        controlText2.style.color = "rgb(25,25,25)";
        controlText2.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText2.style.fontSize = "16px";
        controlText2.style.lineHeight = "38px";
        controlText2.style.paddingLeft = "5px";
        controlText2.style.paddingRight = "5px";
        controlText2.innerHTML = "Floor Down";
        controlUI2.appendChild(controlText2);

        controlUI2.addEventListener("click", async () => {
          console.log("floor down");

          if (state.currentFloorNumber === 0) {
            console.log("lowest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber - 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;
            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });
      };

      var floorControlDiv = document.createElement("div");
      floorChange(floorControlDiv);
      //@ts-ignore
      map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(
        floorControlDiv
      );
    };

    if (!!mapElement) {
      //@ts-ignore
      map = new google.maps.Map(mapElement, mapOptions);
      initialize();
    } else {
      console.log("no map element");
    }
  };

  const drawPoly = () => {
    console.log("here", props);
    if (props.boundary) {
      try {
        poly.setMap(null);
      } catch (e) {
        console.log("no polyine");
      }
      console.log("there");
      let coords: LocationPosition[][] = [props.boundary];
      props.holes.forEach((hole) => {
        coords.push(hole);
      });
      console.log(
        "🚀 ~ file: ZoneAddMap.tsx ~ line 381 ~ drawPoly ~ coords",
        coords
      );
      poly = new google.maps.Polygon({
        paths: coords,
        strokeColor: "#FFC107",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FFC107",
        fillOpacity: 0.35,
      });
      poly.setMap(map);
    }
  };

  useEffect(() => {
    console.log("props updaed");
    drawPoly();
  }, [props]);

  //   useEffect(() => {
  //     drawPoly();
  //   }, [props.holes]);

  useEffect(() => {
    if (!!data) {
      let googleMapPromise = getGoogleMaps();
      CenterLat = currentBuilding?.centerLat;
      CenterLng = currentBuilding?.centerLong;
      k_diff = floorOverlays[state.currentFloorNumber].k_diff;
      D_diff = floorOverlays[state.currentFloorNumber].D_diff;
      rot = floorOverlays[state.currentFloorNumber].Rot;
      if (!window.google) {
        Promise.all([googleMapPromise]).then((values) => {
          initMap(props.mapId);
        });
      } else {
        initMap(props.mapId);
      }
    }
  }, [data]);

  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const styles = {
      container: {
        height: "70vh",
        width: "100%",
        //display: 'flex',
        //flexDirection: 'column',
      },
    };

    return (
      <MapContainer>
        <div id={props.mapId} ref={props.innerRef} style={styles.container} />
      </MapContainer>
    );
  }
}
